'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTranslationStyles = undefined;

var _immutableHelper = require('../../common/utils/immutableHelper');

var getTranslationStyles = exports.getTranslationStyles = function getTranslationStyles(translationPoint) {
    var x = (0, _immutableHelper.prop)('x', translationPoint);
    var y = (0, _immutableHelper.prop)('y', translationPoint);
    var transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    return {
        transform: transform,
        WebkitTransform: transform
    };
}; // Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/cssUtil.js
// module id = 312
// module chunks = 0